class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.continue-shopping').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  updateCartDrawer() {

    fetch(window.Shopify.routes.root + "?sections=cart-drawer")
      .then(async (res) => {

        let cartDrawer = await res.json();
        cartDrawer = cartDrawer['cart-drawer'];
        cartDrawer = cartDrawer.replace('cart.js', 'carts.js');
        $('#shopify-section-cart-drawer').html('');
        $('#shopify-section-cart-drawer').replaceWith(cartDrawer);
      });

  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    this.updateCartDrawer();
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

   
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    // setTimeout(window.location.reload(), 1000);
  }

  renderContents(parsedState) {
 
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (this.header) this.header.reveal();
    let prod_url_arr = parsedState.url.split('?')
    if (parsedState.properties._editCustomizations === undefined) {
     
      if(document.getElementById('customization-link') !== null) {
      document.getElementById('customization-link').remove();
      }
    } else {
      document.getElementById('customization-link').setAttribute('href', prod_url_arr[0] + '?editCustomizations=' + parsedState.properties._editCustomizations)
    }
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
